module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-navy-2-fab84b1db16df0f72b76d968e3720048.png";